import { Component } from '@angular/core';
import { ToastService } from './toast.service';
import { ViewChildren, QueryList, ElementRef } from '@angular/core';
@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
    toast$ = this.toastService.toast$;

    constructor(private toastService: ToastService) {}

    @ViewChildren('modalFocus', { read: ElementRef })
    modalFocusElements!: QueryList<ElementRef>;

    handleModalKeydown(event: KeyboardEvent): void {
        if (event.key !== 'Tab') {
            return;
        }

        const focusable = Array.from(
            document.querySelectorAll<HTMLElement>('.modal-focus')
        );

        if (focusable.length === 0) {
            return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement as HTMLElement;

        // Shift + Tab
        if (event.shiftKey) {
            if (active === first) {
                event.preventDefault();
                last.focus();
            }
        } 
        // Tab normal
        else {
            if (active === last) {
                event.preventDefault();
                first.focus();
            }
        }
    }
}